// E-Ticaret › Ürün Soruları (Platform Ürün Soruları) sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'ecommerce.productQuestions';

export const ecommerceProductQuestionsGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Platform Ürün Soruları nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Pazaryerlerinde müşterilerin ürünleriniz hakkında sorduğu soruları tek ekranda görürsünüz. Şu anda yalnız N11 gerçek bağlantıyla çalışır; sorular buraya çekilir ve okunur, yanıt pazaryerinin kendi panelinden verilir. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Platform Ürün Soruları'),
    toolbar: t(`${G}.regions.toolbar`, 'Platform Sorularını Çek'),
    filters: t(`${G}.regions.filters`, 'Platform sekmeleri'),
    stats: t(`${G}.regions.stats`, 'Soru sayıları'),
    table: t(`${G}.regions.table`, 'Soru listesi'),
  },
  steps: [
    {
      region: 'filters',
      title: t(`${G}.s1.title`, '1. Platformu seçin'),
      text: t(`${G}.s1.text`, 'Üstteki sekmelerden Trendyol, Hepsiburada, N11 veya Amazon\'u seçin. Sekmedeki kırmızı rozet o platformda yanıt bekleyen soru sayısını gösterir.'),
      tips: [
        t(`${G}.s1.tip1`, 'Şu anda yalnız N11 gerçek API ile çalışır. Trendyol, Hepsiburada ve Amazon sekmelerinde entegrasyon henüz hazır değildir; bu sekmeler yalnız demo içindir ve gerçek soru göstermez.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s2.title`, '2. Soruları çekin'),
      text: t(`${G}.s2.text`, 'N11 sekmesindeyken "Platform Sorularını Çek" düğmesine basın; N11 mağazanızdaki sorular (en çok 100 adet) listeye gelir. Sayfa ilk açıldığında liste boştur; soruları her seferinde bu düğmeyle çekersiniz.'),
      tips: [
        t(`${G}.s2.tip1`, 'Sekme değiştirip geri döndüğünüzde liste boşalır; soruları yeniden çekin.'),
      ],
    },
    {
      region: 'stats',
      title: t(`${G}.s3.title`, '3. Sayıları okuyun'),
      text: t(`${G}.s3.text`, 'Kartlar listedeki Toplam Soru, Bekleyen, Yanıtlanan ve Reddedilen soru sayılarını gösterir. Cevabı olan soru "Yanıtlandı", cevabı olmayan soru "Bekliyor" sayılır.'),
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Soruyu inceleyin'),
      text: t(`${G}.s4.text`, 'Her satırda Ürün (ve ürün ID\'si), Soru, Müşteri, Tarih ve Durum görünür; yanıtlanmış sorularda mağaza cevabı sorunun altında yeşil kutuda yer alır. Göz simgesi (Detayları Görüntüle) ürün bilgisi, müşteri sorusu ve mağaza cevabını ayrıntılı açar.'),
      tips: [
        t(`${G}.s4.tip1`, 'N11 müşteri adını ve soru tarihini göndermez; Müşteri sütununda "N11 Müşterisi", tarih olarak da soruların çekildiği an görünür.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Soruyu yanıtlayın'),
      text: t(`${G}.s5.text`, 'N11 API\'si üzerinden sorulara cevap verilemez. Bekleyen bir soruyu yanıtlamak için N11 Mağaza Yönetim Paneli\'ni (panel.n11.com/magaza/urun-sorularim) kullanın; sonra "Platform Sorularını Çek" ile listeyi yenileyince soru "Yanıtlandı" olarak görünür.'),
      tips: [
        t(`${G}.s5.tip1`, 'Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
      ],
    },
  ],
});
